import Cookies from 'js-cookie';
import { track } from './sensorTrack';

const TAG = '[FP]';

const REQUEST_ID = 'requestId';

export const EVENTS = {
  FP_REQUEST_ID: 'FPRequestId',
  FP_REQUEST_ID_EMPTY: 'FPRequestIdEmpty',
  FP_REQUEST_ID_ERROR: 'FPRequestIdError',
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function log(message?: any, ...optionalParams: any[]) {
  if (optionalParams.length === 0) {
    console.log(`${new Date().getTime()} ${TAG} ${!!message ? message : ''}`);
    return;
  }
  console.log(`${new Date().getTime()} ${TAG} ${!!message ? message : ''}`, optionalParams);
}

export function getSavedFingerprintID() {
  try {
    let requestId: string | undefined | null = Cookies.get(REQUEST_ID);

    // 服务端渲染时，window对象是不存在的，所以需要判断是否存在window对象
    // 不能直接用 window != null, 因为 window 是不存在的，仍然会报错 ReferenceError: window is not defined
    // https://stackoverflow.com/questions/55151041/window-is-not-defined-in-next-js-react-app
    if (!requestId && typeof window !== 'undefined' && window.localStorage) {
      requestId = window.localStorage.getItem(REQUEST_ID);
    }
    return requestId;
  } catch (error) {
    log('getSavedFingerprintID error: ', error);
  }
  return null;
}

export async function ensureFingerprint(bizType: FingerprintBizType) {
  try {
    // 从 cookie 中读取 requestId，如果读不到就从 localStorage 中读取，如果还是读不到就生成一个新的 requestId
    const requestId = getSavedFingerprintID();
    if (!requestId) {
      log('no requestId found, try again...');
      await generateFingerprint(bizType);
    }
  } catch (error) {
    log('ensureFingerprint error:', error);
  }
}

async function generateFingerprint(bizType: FingerprintBizType) {
  try {
    let mode = process.env.NEXT_PUBLIC_MODE;
    if (mode !== 'prod') {
      mode = 'dev';
    }

    /*
      https://web3-holdings-limited.jp.larksuite.com/wiki/UgJBwlAjqi2gx2kun6djeZDkpkg
      需要增加 webpackIgnore: true 来让 webpack 打包的时候忽略这个 module
      否则运行时会报错：
      Module build failed: UnhandledSchemeError: Reading from "https:..." is not handled by plugins (Unhandled scheme).
      Webpack supports "data:" and "file:" URIs by default.
      You may need an additional plugin to handle "https:" URIs.
    */
    window.fpPromise = import(
      /* webpackIgnore: true */ 'https://blockfin.com/KxLsFiRJGfcr87HW/cxiAN1yzACugGJkm?apiKey=5meRuHbJtN2gGIf82T5y'
    ).then((FingerprintJS) =>
      FingerprintJS.load({
        endpoint: ['https://blockfin.com/KxLsFiRJGfcr87HW/w514pAALmBqwcf97?region=ap', FingerprintJS.defaultEndpoint],
        region: 'ap',
      })
    );

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return await (window.fpPromise as Promise<any>)
      .then((fp) => fp.get({ tag: { env: mode, biz_type: bizType, client: 'web' } }))
      .then((result) => {
        const date = new Date();
        date.setFullYear(date.getFullYear() + 3); // 设置为当前日期的3年后
        const expires = 'expires=' + date.toUTCString();
        const requestId = result.requestId;

        !!requestId
          ? track(EVENTS.FP_REQUEST_ID, { fp_request_id: JSON.stringify(requestId), biz_type: bizType })
          : track(EVENTS.FP_REQUEST_ID_EMPTY, { biz_type: bizType });

        document.cookie = 'requestId=' + requestId + '; path=/; ' + expires;
        if (window && window.localStorage) {
          window.localStorage.setItem('requestId', requestId);
        }
      })
      .catch((error) => {
        track(EVENTS.FP_REQUEST_ID_ERROR, { error_msg: JSON.stringify(error), biz_type: bizType });
        log('generateFingerprint error:', error);
      });
  } catch (error) {
    track(EVENTS.FP_REQUEST_ID_ERROR, { error_msg: JSON.stringify(error), biz_type: bizType });
    log('generateFingerprint error:', error);
  }
}
